module.exports = __webpack_public_path__ + "static/media/waveDark.785dd65b.svg";